/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Signup reducers.
 */
import { combineReducers } from 'redux';
import ReduxUtils from '../../utils/ReduxUtils';
import * as ACTIONTYPES from './actionTypes';

/**
 * Updates the user input data for the signup page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function userInputReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.SIGNUP_USER_INPUT
  });
}

/**
 * Updates the flag that determines if the username field is shown or hidden on the Signup page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function isUsernameVisibleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.SIGNUP_SET_SHOW_USERNAME_FIELD
  });
}

/**
 * Updates the validation errors for the Signup page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function validationErrorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.SIGNUP_VALIDATION_ERRORS
  });
}

/**
 * Updates the flag that is set while the post data request is in progress for the Signup page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function isPostingDataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ACTIONTYPES.SIGNUP_POST_ACTION_TYPES);
}

/**
 * Updates the post data errors for the Signup page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function postDataErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.SIGNUP_POST_ACTION_TYPES);
}
var reducers = combineReducers({
  isUsernameVisible: isUsernameVisibleReducer,
  userInput: userInputReducer,
  validationErrors: validationErrorsReducer,
  postDataError: postDataErrorReducer,
  isPostingData: isPostingDataReducer
});
export default {
  reducers: reducers
};